module.exports = __webpack_public_path__ + "public/images/header/preview.4e8dfe7fac5c35f8a8708512e6539e66.jpg";